import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

import './index.css'
import './common.css'
// Leaflet base stylesheet — required for the Project Map dashboard's tile
// rendering, control positioning, and marker icons. Pulled in globally
// (rather than lazy-loaded inside the map component) so it ships in the main
// CSS bundle and avoids a FOUC the first time the map mounts.
import 'leaflet/dist/leaflet.css'

// Global axios 401 handler — must run BEFORE any API calls are made so an
// expired JWT triggers a clean redirect to /login instead of leaving raw
// "Unable to load…" errors on the dashboard.
import { installSessionExpiryInterceptor } from './lib/sessionExpiry'
installSessionExpiryInterceptor()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
